"use strict";

(() => {

const templates = {
    filterItem: `<div data-title="[[FILTER_TITLE]]" data-attr-key="[[FILTER_ATTR_KEY]]" class="widget sidebar-tags [[FILTER_ACCORDION_CLASS]]" role="region" aria-labelledby="filter-[[FILTER_ATTR_KEY]]">
                    <div class="widget-title">
                        <div class="sidebar-title" role="button" tabindex="0" [[FILTER_ACCORDION_ATTR]] id="filter-[[FILTER_ATTR_KEY]]" aria-controls="filter-content-[[FILTER_ATTR_KEY]]">
                            <span>[[FILTER_TITLE]] </span>
                            [[FILTER_SELECTED_COUNT]]
                        </div>
                    </div>
                    <div class="widget-content filter_search_wrapper collection-price-range" data-filter-option-container [[FILTER_ACCORDION_STYLE]] id="filter-content-[[FILTER_ATTR_KEY]]" role="group">
                        <ul class="list-tags" role="list">
                            [[FILTER_OPTIONS]]
                        </ul>
                    </div>
                </div>`,
    filterOption: `<li role="listitem">
                        <input aria-controls="sr-status" type="checkbox" id="[[FILTER_OPTION_ID]]" value="[[FILTER_OPTION_VALUE]]" [[FILTER_OPTION_SELECTED]] />
                        <label for="[[FILTER_OPTION_ID]]">[[FILTER_OPTION_TITLE]]</label>
                    </li>`,
    filterPriceOption: ` <li data-value="Price" class="price-filter">
                            <div class="price-selected">
                                <span id="price-selected-min" class="price-selected-col price-selected-min" aria-live="assertive" data-min-price="[[PRICE_LEFT]]">
                                    <span class="visually-hidden">minimum price [[PRICE_LEFT]]</span>
                                    <span aria-hidden="true">[[PRICE_LEFT]]</span>
                                </span>
                                <span id="price-selected-max" class="price-selected-col price-selected-max" aria-live="assertive" data-max-price="[[PRICE_RIGHT]]">
                                    <span class="visually-hidden">maximum price [[PRICE_RIGHT]]</span>
                                    <span aria-hidden="true">[[PRICE_RIGHT]]</span>
                                </span>
                            </div>
                            <div id="filter-price-range"></div>
                            <div class="price-range-info">
                                <input type="text" aria-label="minimum price [[PRICE_FROM]]" class="price-range-info-min" data-price-from="[[PRICE_FROM_UNFORMATTED]]" value="[[PRICE_FROM]]" tabindex="-1" readonly />
                                <input type="text" aria-label="maximum price [[PRICE_TO]]" class="price-range-info-max" data-price-to="[[PRICE_TO_UNFORMATTED]]" value="[[PRICE_TO]]" tabindex="-1" readonly />
                                <input type="hidden" name="restrictBy[price]" class="price-range-full" value="[[PRICE_FROM_TO_UNFORMATTED]]" readonly />
                            </div>
                        </li>`
};

class SearchanizeProducts extends HTMLElement {

    settings = {
        cachedData: {},
        startIndex: 0,
        currentPage: 0,
        isLoading: false,
        isLoadMore: false,
        isPriceFilter: false,
        renderOfferTemplate: false,
        infiniteScrollObserver: null,
        isMobile: window.innerWidth <= 767,
        similarProductTotalItems: 0,
        similarProductStartIndex: 0,
        similarProductCurrentPage: 0,
        similarProductItemsPerPage: 15,
    };
    constructor() {
        super();
        const self = this;
        this.searchQuery = '';
        this.productHandle = '';
        this.pageType = this.getAttribute('data-page-type');
        this.isShowingSimilarProducts = false;

        if (this.pageType === 'search') {
            this.collectionHandle = '';
        } else {
            this.collectionHandle = this.getAttribute('data-handle');
            if(!this.collectionHandle) return;

            if (this.collectionHandle.includes("3-for-99") || this.collectionHandle.includes("3-for-99-perfumes-and-colognes") || this.collectionHandle.includes('flash-sale')) {
                this.settings.renderOfferTemplate = true;
            }
        }

        this.buildSelectors();
        this.fetchProducts(true);
    }

    buildSelectors(){
        this.selectors = {};
        this.selectors.html = document.querySelector('html');
        this.selectors.body = document.querySelector('body');
        this.selectors.overlay = document.querySelector('.wrapper-overlay');
        
        this.selectors.srStatus = this.querySelector('#sr-status');
        this.selectors.mainContainer = this.querySelector('[data-main-container]');
        this.selectors.sidebarContainer = this.querySelector('[data-sidebar-container]');

        if(this.settings.isMobile) {
            this.selectors.filterContainer = this.querySelector('[data-mobile-filter] [data-filter-container]');
        } else {
            this.selectors.filterContainer = this.querySelector('[data-desktop-filter] [data-filter-container]');
        }
        this.selectors.productsContainer = this.querySelector('[data-products-container]');
        
        this.selectors.mobFilterOpen = this.querySelector('[data-mob-filter-open]');
        this.selectors.mobFilterClose = this.querySelectorAll('[data-mob-filter-close]');

        this.selectors.sortByDiv = this.querySelector('[data-sortby]'); // Done
        this.selectors.sortByBtn = this.querySelector('[data-sortby] [data-sortby-btn]'); // Done
        this.selectors.sortByList = this.querySelector('[data-sortby] [data-sortby-list]'); // Done

        this.selectors.showDiv = this.querySelector('[data-limited-view]'); // Done
        this.selectors.showBtn = this.querySelector('[data-limited-view] [data-showProduct-btn]'); // Done
        this.selectors.showList = this.querySelector('[data-limited-view] [data-showProduct-list]'); // Done

        this.selectors.loadMoreBtn = this.querySelector('[data-loadmore-btn]');
        this.selectors.productCounts = this.querySelectorAll('[data-result-count]');

        this.selectors.productsBannerTop = this.querySelector('[data-banner-top]');
        this.selectors.productsBannerBottom = this.querySelector('[data-banner-bottom]');
        
        this.selectors.searchQuery = this.querySelector('[data-search-query]');
        this.selectors.searchResultInfo = this.querySelector('[data-search-result-info]');

        this.selectors.clearAllBtns = this.querySelectorAll('[data-filter-clear-all]');
        this.selectors.viewAllBtnMob = this.querySelector('[data-mob-filter-close].apply-mob-filter');
        this.selectors.clearAllBtnMob = this.querySelector('[data-filter-clear-all].clear-mob-filter');
        this.selectors.clearAllBtnDesk = this.querySelector('[data-filter-clear-all].clear-desk-filter');
        this.collectionDefaultEnable = this.getAttribute('data-collection-defult-enable');
        this.collectionDefaultSorting = this.getAttribute('data-collection-defult-sorting');
    }
    buildAPIURL(initialRender){
        
        let baseurl = 'https://www.searchanise.com/getresults?api_key=3R1z2i6V5n&items=true&facets=true&facetsShowUnavailableOptions=false&output=jsonp&truncateData=false&custom_fields=metafields.custom.top_notes,metafields.custom.middle_notes,metafields.custom.base_notes';
        
        const selectedFilterValues = Array.from(
            this.selectors.filterContainer.querySelectorAll('[data-attr-key]')
        ).map(filterItem => {
            let values = '';
            const attrKey = filterItem.dataset.attrKey;
            const selectedInputs = Array.from(filterItem.querySelectorAll('[data-filter-option-container] input[type="checkbox"]:checked'));

            if(attrKey == 'price' && this.settings.isPriceFilter){
                let min = filterItem.querySelector('[data-filter-option-container] ul li .price-selected #price-selected-min').getAttribute('data-min-price');
                let max = filterItem.querySelector('[data-filter-option-container] ul li .price-selected #price-selected-max').getAttribute('data-max-price');

                min = min.replace("$", "");
                max = max.replace("$", "");
                values = min +','+ max;
                selectedInputs.length = 1;
            } else {
                values = selectedInputs.map(input => encodeURIComponent(input.value.trim())).join('|');
            }

            return selectedInputs.length === 0 ? '' : `restrictBy[${attrKey}]=${values}`;
        }).filter(value => value);

        const selectedShowValue = this.selectors.showList.querySelector('[aria-selected="true"][data-value]')?.getAttribute('data-value') || '12';
        

        if(selectedFilterValues.length) baseurl += `&${selectedFilterValues.join('&')}`;

        
      

        baseurl += this.collectionSorting(initialRender,baseurl);
        baseurl += `&startIndex=${this.settings.startIndex}&maxResults=${selectedShowValue}`;

        const url_obj = new URL(window.location.href);
        this.searchQuery = url_obj.searchParams.get('q') || '';
        if (this.searchQuery && this.pageType === 'search') {
            baseurl += `&q=${encodeURIComponent(this.searchQuery)}`;
        }

        if (this.collectionHandle != '' && this.pageType === 'collection') {
            baseurl += `&categories=true&collection=${this.collectionHandle}`;
        }

        return baseurl;
    }


    collectionSorting(initialRender,baseurl) {
        let selectedSortByValue = this.selectors.sortByList.querySelector('[aria-selected="true"][data-value]')?.getAttribute('data-value') || 'sales_amount&sortOrder=desc';
        if (initialRender) {
            if (
            this.collectionDefaultEnable == 'true' ||
            this.collectionDefaultEnable == true
            ) {
                if (this.collectionDefaultSorting.indexOf('price-descending') > -1) {
                    selectedSortByValue = 'price&sortOrder=desc';
                } else if (this.collectionDefaultSorting.indexOf('price-ascending') > -1) {
                    selectedSortByValue = 'price&sortOrder=asc';
                } else if (this.collectionDefaultSorting.indexOf('created-descending') > -1) {
                    selectedSortByValue = 'created&sortOrder=desc';
                } else if (this.collectionDefaultSorting.indexOf('best-selling') > -1) {
                    selectedSortByValue = 'sales_amount&sortOrder=desc';
                } else if (this.collectionDefaultSorting.indexOf('manual') > -1) {
                    selectedSortByValue = 'sales_amount&sortOrder=desc';
                }
                baseurl += `&sortBy=${selectedSortByValue}`;
                const element = document.querySelector(
                    '.filters-toolbar__sortby #sortby-comb-listbox li[data-value="' + selectedSortByValue + '"]'
                );
                if (element) {
                    // Update label text
                    const labelText = document.querySelector(
                    '.filters-toolbar__sortby .select-combo-input'
                    );
                    if (labelText) {
                    labelText.textContent = element.textContent;
                    }

                    // Set selected state for the target element
                    element.setAttribute('aria-selected', 'true');
                    element.classList.add('active');

                    // Remove selected state from other elements
                    const allElements = document.querySelectorAll('.filters-toolbar__sortby #sortby-comb-listbox li');
                    allElements.forEach((el) => {
                    if (el.getAttribute('data-value') !== selectedSortByValue) {
                        el.setAttribute('aria-selected', 'false');
                        el.classList.remove('active');
                    }
                    });
                }
            } else {
              baseurl += `&sortBy=${selectedSortByValue}`;
            }
        } else {
            baseurl += `&sortBy=${selectedSortByValue}`;
        }
        return baseurl;
    }

    async fetchProducts(initialRender) {

        try {
            _theme.toggleLoading(true);

            // Handle similar search load more
            if (this.isShowingSimilarProducts && !initialRender) {
                return await this.loadMoreSimilarProducts();
            }

            const apiUrl = this.buildAPIURL(initialRender);
            if(!apiUrl) { throw new Error('Invalid API URL'); }
            
            if(this.settings.infiniteScrollObserver) {
                this.settings.infiniteScrollObserver.unobserve(this.selectors.loadMoreBtn);
            }
            
            let result = null;
            this.settings.isLoading = true;
            this.updateSRStatus();

            if(this.settings.cachedData[apiUrl]) {
                result = this.settings.cachedData[apiUrl];
            } else {
                const resp = await fetch(apiUrl);
                if(!resp.ok) { throw new Error(`Error: ${resp}`); }

                result = await resp.json();
                if(!result) { throw new Error('Invalid Response'); }
                
                this.settings.cachedData[apiUrl] = result;
            }

            if(result.totalItems === 0){
                if (this.pageType === 'search') {
                    // Try to get similar products using fuzzy matching
                    this.trySimilarProducts();
                } else {
                    this.selectors.mainContainer.querySelector('[data-toolbar-container]').classList.add('hidden');
                    this.selectors.productsContainer.innerHTML = '<p class="col-12 text-center">Sorry, there are no products in this collection</p>'; 
                }
            } else {
                this.renderProducts(result);
                this.renderFilters(result);
                if(initialRender){
                    this.initInitialEvents();
                }
                this.initInfiniteScrollLoadMore(result);
                this.settings.isLoadMore = false;
                this.settings.isLoading = false;
                _theme.Wishlist.init();

                // Reinitialize product preview sizes after products are rendered
                new productPreviewSizes();
            }

            if (this.pageType === 'search') {
                const searchTxt = `${result.totalItems} Search results for ${this.searchQuery}`;
                if(this.selectors.searchQuery) {
                    this.selectors.searchQuery.innerHTML = `“${this.searchQuery}”`;
                    this.selectors.searchResultInfo.setAttribute('aria-label', searchTxt);
                    this.selectors.searchResultInfo.setAttribute('role', 'alert');
                }
                this.selectors.productCounts.forEach(countElem => {
                    countElem.textContent = `(${result.totalItems} ${result.totalItems > 1 ? 'Products' : 'Product'})`;
                }); 
            }
            
            setTimeout(() => {
                this.updateSRStatus();
                _theme.toggleLoading(false);
            }, 500)
            
        } catch (error) {
            console.error('Error:', error);
            _theme.toggleLoading(false);
        }
    }

    renderProducts(result){
        if(!result || result.totalItems === 0) return;

        let count = 0;
        let mainHtml = '';

        result.items.forEach((product, index) => {

            // Filter: For offer collections, only show products with offer variants in stock
            let offerVariant = null;
            if (this.settings.renderOfferTemplate) {
                // Check if product has offer metafield (applicable_offer)
                const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;
                
                if (productOffer) {
                    // Find variant that has is_offer_applicable = true AND is in stock
                    offerVariant = product.shopify_variants?.find(
                    (variant) =>
                        variant.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" &&
                        variant.available !== "0"
                    );
                    
                    // Skip this product if no offer variant is in stock
                    if (!offerVariant) {
                        return;
                    }
                }
            }

            count = count + 1;
            this.productHandle = product.link.split('products/')[1];
            const productImages = this.buildProductImage(product);
            const maxDiscountData = this.getMaxDiscountAndvariant(product);
            
            // Check if timer is active and timer is active and flash sale extension shop metafield is active
            const timerSettings = window.countdownTimerSettings || {};
            const isTimerActive = this.isTimerActive(timerSettings);
            const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;
            
            // Filter variants that have flash sale metafield with value 'true' and are available
            const flashVariants = product.shopify_variants.filter(
                (variant) =>
                    variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
                    variant.available !== '0'
            );
            
            // Check if any flash variant exists and timer is active and flash sale extension shop metafield is active
            let productUrl = (maxDiscountData.availableMaxDiscountVariant && maxDiscountData.availableMaxDiscountVariant.link) || product.link;
            if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
                const flsVar = flashVariants[0];
                if (flsVar != undefined && flsVar != null) {
                    productUrl = flsVar.link;
                }
            }
            
            const collectionUrl = '/collections/' + _theme.Helpers.handleize(product.vendor) || '';
            
            let vid = '';
            if (offerVariant) {
                vid = offerVariant.variant_id;
            } else {
                let variant = product.shopify_variants?.find(v => v.available != "0");
                if(!variant) vid = product.shopify_variants[0].variant_id;
                else vid = variant.variant_id;
            }
            
            let prodType = '';
            if(product.metafield_9e14d49086f4ac1134f463aa2738d80e != undefined) {
                prodType = product.metafield_9e14d49086f4ac1134f463aa2738d80e
            } else if(product.product_type !== undefined) {
                prodType = product.product_type
            }

            let variantClass = 'multiple-variant';
            let variantLength = product.shopify_variants.length;
            if(variantLength && variantLength === 1) { variantClass = 'single-variant'; }

            let product_html = this.settings.renderOfferTemplate ? _theme.product_html.productGridOffer : _theme.product_html.productGridNew;

            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Variants_JSON]]', this.buildPrevProductVariantsJSON(product));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Variant_Id]]', vid);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Id]]', product.product_id);

            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_URL]]', productUrl);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Title]]', product.title);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Type_Meta]]', prodType);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Image_1]]', productImages.image_1);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Vendor]]', product.vendor || '');
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Vendor_Url]]', collectionUrl);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Handle]]', this.productHandle);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Collection_Handle]]', this.collectionHandle);

            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Variant_Class]]', variantClass);
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Grid_Class]]', this.buildGridClass(product));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Notify_Me_Btn]]', this.buildNotifyMeBtn(product));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_GWP_Properties]]', this.getGwpProperties(product));
            
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Labels]]', this.buildProductLabels(product));
            product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Labels_Bogo]]', this.buildProductLabelsBogo(product));

            if(this.settings.renderOfferTemplate) {
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Price_Offer]]', this.buildProductPriceOffer(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_QV_Btn_D_Offer]]', this.buildProductQvBtnDeskOffer(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_QV_ATC_Btn_M_Offer]]', this.buildProductQvAtcBtnMobOffer(product));
            } else {
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Price]]', this.buildProductPrice(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_QV_ATC_Btn_M]]', this.buildProductQvAtcBtnMob(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_QV_ATC_Btn_D]]', this.buildProductQvAtcBtnDesk(product));
                
                product_html = _theme.Helpers.updateHtml(product_html, '[[Prev_Product_Price_M]]', this.buildPrevProductPrice(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Prev_Product_Image_M]]', this.buildPrevProductImage(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Prev_Product_Description_M]]', this.buildPrevProductDescription(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Prev_Product_ATC_Btn_D]]', this.buildPrevProductAtcBtn(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_ATC_Btn_Price]]', this.buildPrevProductAtcBtn(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Prev_Product_Select_Options]]', this.buildPrevProductSelectOptions(product));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Prev_Product_Variant_Radios_M]]', this.buildPrevProductVariantListMobile(product, 'mobile'));
                product_html = _theme.Helpers.updateHtml(product_html, '[[Prev_Product_Variant_Radios_D]]', this.buildPrevProductVariantListDesktop(product, 'desktop'));
            }

            if(productImages.image_2) {
                product_html = _theme.Helpers.updateHtml(product_html, '[[Image_1_Class]]', 'images-one');
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Image_2]]', productImages.image_2);
            } else {
                product_html = _theme.Helpers.updateHtml(product_html, '[[Image_1_Class]]', '');
                product_html = _theme.Helpers.updateHtml(product_html, '[[Product_Image_2]]', '');
            }

            if(count == 1 && !this.settings.isLoadMore){
                mainHtml += this.selectors.productsBannerTop.innerHTML; 
            }

            mainHtml += product_html;

            if(count == 12 && !this.settings.isLoadMore){
                mainHtml += this.selectors.productsBannerBottom.innerHTML;
            }
        });

        if(this.settings.isLoadMore){
            const oldHtml = this.selectors.productsContainer.innerHTML;
            this.selectors.productsContainer.innerHTML = oldHtml + mainHtml;
            this.settings.isLoadMore = false;
        } else {
            this.selectors.productsContainer.innerHTML = mainHtml;
        }

        if (this.pageType === 'search') {
            this.closest('[data-search-container]').querySelector('[data-sidebar-container]').classList.remove('hidden');
            this.closest('[data-search-container]').querySelector('[data-products-container]').classList.remove('hidden');
            this.closest('[data-search-container]').querySelector('[data-toolbar-container] .column-right').classList.remove('hidden');
            this.closest('[data-search-container]').querySelector('[data-no-search-container]').classList.add('hidden');

            const imageCardElement = document.querySelector('.image-with-text-card-main-container .search-result-featured-grid');
            if (imageCardElement) imageCardElement.classList.add('hidden');
        } else { 
            this.selectors.mainContainer.querySelector('[data-toolbar-container]').classList.remove('hidden');
        }

        this.selectors.productCounts.forEach(countElem => {
            countElem.textContent = `(${result.totalItems} ${result.totalItems > 1 ? 'Products' : 'Product'})`;
        });
        this.selectors.viewAllBtnMob.innerHTML = `View (${result.totalItems})`;
    }
    renderFilters(result){
        if(!result || result.totalItems === 0) return;

        let mainHtml = '';
        let filter_Selected = false;
        let price_from = 0, price_to = 0, price_from_left = 0, price_to_left = 0;

        result.facets.forEach((facet, facetIndex) => {
            let filterOptionMainHtml = '';
            let item_title = facet.title.trim().toLowerCase();

            let filterItemHtml = templates.filterItem; 
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_TITLE]]', facet.title);
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_ATTR_KEY]]', facet.attribute);
            
            let filter_selected_count = 0;
            let filter_open_accordion = false;
            facet.buckets.forEach((option, optionIndex) => {
                if(item_title == 'price') {
                    
                    price_from = Number(option.from);
                    price_to = Number(option.to);
                    price_from_left = Number(option.left);
                    price_to_left = Number(option.right);

                    const price_from_formatted = Shopify.formatMoney((price_from*100), window.money_format);
                    const price_to_formatted = Shopify.formatMoney((price_to*100), window.money_format);
                    const price_left_formatted = Shopify.formatMoney((price_from_left*100), window.money_format);
                    const price_right_formatted = Shopify.formatMoney((price_to_left*100), window.money_format);
                    let priceOptionHtml = templates.filterPriceOption;

                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_FROM_UNFORMATTED]]', price_from);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_TO_UNFORMATTED]]', price_to);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_LEFT]]', price_left_formatted);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_RIGHT]]', price_right_formatted);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_FROM]]', price_from_formatted);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_TO]]', price_to_formatted);
                    priceOptionHtml = _theme.Helpers.updateHtml(priceOptionHtml, '[[PRICE_FROM_TO_UNFORMATTED]]', 'restrictBy[price]=' + price_from +','+price_to);
                    filterOptionMainHtml += priceOptionHtml;

                } else {
                    let optionHtml = templates.filterOption;
                    optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[FILTER_OPTION_ID]]', _theme.Helpers.handleize(`${facet.title}-${option.value}-${optionIndex}`));
                    optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[FILTER_OPTION_VALUE]]', option.value);
                    optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[FILTER_OPTION_TITLE]]', option.value +' ('+option.count+')');
                    optionHtml = _theme.Helpers.updateHtml(optionHtml, '[[FILTER_OPTION_SELECTED]]', option.selected === "true" ? "checked" : "");
                    filterOptionMainHtml += optionHtml;
                }
                if (option.selected === "true") {
                    filter_Selected = true;
                    filter_selected_count += 1;
                    filter_open_accordion = true;
                }
                if (facetIndex === 0 && !this.settings.isMobile) {
                    filter_open_accordion = true;
                }
            });
            
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_OPTIONS]]', filterOptionMainHtml);
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_SELECTED_COUNT]]', filter_selected_count > 0 ? `(${filter_selected_count})` : '');
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_ACCORDION_CLASS]]', filter_open_accordion ? 'open-accordion' : '');
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_ACCORDION_ATTR]]',  filter_open_accordion ? 'aria-expanded="true"' : 'aria-expanded="false"');
            filterItemHtml = _theme.Helpers.updateHtml(filterItemHtml, '[[FILTER_ACCORDION_STYLE]]', filter_open_accordion ? 'style="display:block"' : 'style="display:none"');
            mainHtml += filterItemHtml;
        });

        this.selectors.filterContainer.innerHTML = mainHtml;
        
        this.selectors.viewAllBtnMob.classList.toggle('disabled', !filter_Selected);
        this.selectors.clearAllBtnMob.classList.toggle('disabled', !filter_Selected);
        this.selectors.clearAllBtnDesk.style.display = filter_Selected ? 'block' : 'none';

        this.selectors.overlay.addEventListener('click', this.closeMobSidebarFilter.bind(this));
        this.selectors.mobFilterOpen.addEventListener('click', this.openMobSidebarFilter.bind(this));
        this.selectors.mobFilterClose.forEach(btn => {
            btn.addEventListener('click', this.closeMobSidebarFilter.bind(this));
        });

        const filterContainerBtns = this.selectors.filterContainer.querySelectorAll('.sidebar-title');
        filterContainerBtns.forEach(btn => {
            btn.addEventListener('click', evt => {
                const parent = btn.closest('.widget');
                const title = parent.querySelector('.sidebar-title');
                const content = parent.querySelector('.widget-content');
                parent.classList.toggle('open-accordion');
        
                const isOpen = content.style.display === 'block';
                content.style.display = isOpen ? 'none' : 'block';
                title.setAttribute('aria-expanded', !isOpen);
            });
        });

        const filterInputs = this.selectors.filterContainer.querySelectorAll('[data-filter-option-container] input[type="checkbox"]');
        filterInputs.forEach(input => {
            input.addEventListener('change', (evt) => {
                this.settings.isPriceFilter = false;
                this.resetFilters();
                this.fetchProducts(false);
            });
        });

        if(price_from != undefined && price_to != undefined){
            const _this = this;
            $(document).ready(function() {
                jQuery( "#filter-price-range" ).slider({
                    range: true,
                    min: price_from,
                    max: price_to,
                    step: 0.1,
                    values: [ price_from_left, price_to_left ],

                    create: function(event, ui) {
                        jQuery('#filter-price-range .ui-slider-handle').attr("role", "button");
                        jQuery('#filter-price-range .ui-slider-handle').first().attr('aria-labelledby', 'price-selected-min');
                        jQuery('#filter-price-range .ui-slider-handle').last().attr('aria-labelledby', 'price-selected-max');
                    },
                    slide: function( event, ui ) {
                        const price_from_formatted = Shopify.formatMoney((ui.values[0]*100), window.money_format);
                        const price_to_formatted = Shopify.formatMoney((ui.values[1]*100), window.money_format);
                        jQuery('.price-selected .price-selected-min').text(price_from_formatted).find('.visually-hidden').text('minimum price ' + price_from_formatted);
                        jQuery('.price-selected .price-selected-max').text(price_to_formatted).find('.visually-hidden').text('minimum price ' + price_to_formatted);
                        jQuery('[data-filter-items] .price-range-full').val('restrictBy[price]=' + ui.values[0] +','+ ui.values[1]);

                        jQuery('.price-selected .price-selected-min').attr('data-min-price', price_from_formatted);
                        jQuery('.price-selected .price-selected-max').attr('data-max-price', price_to_formatted);
                    },
                    change: function( event, ui ) {
                        const price_from_formatted = Shopify.formatMoney((ui.values[0]*100), window.money_format);
                        const price_to_formatted = Shopify.formatMoney((ui.values[1]*100), window.money_format);
                        jQuery('.price-selected .price-selected-min').text(price_from_formatted).find('.visually-hidden').text('minimum price ' + price_from_formatted);
                        jQuery('.price-selected .price-selected-max').text(price_to_formatted).find('.visually-hidden').text('minimum price ' + price_to_formatted);
                        jQuery('[data-filter-items] .price-range-full').val('restrictBy[price]=' + ui.values[0] +','+ ui.values[1]);

                        jQuery('.price-selected .price-selected-min').attr('data-min-price',price_from_formatted);
                        jQuery('.price-selected .price-selected-max').attr('data-max-price',price_to_formatted);
                    },
                    stop: function( event, ui ) {
                        _this.settings.isPriceFilter = true;
                        _this.fetchProducts(false);
                    }
                });
            });
        }
    }
    resetFilters(){
        this.settings.startIndex = 0;
        this.settings.currentPage = 0;
        this.settings.isLoadMore = false;
    }

    // Helper method for similar search API calls
    async fetchSimilarProducts(startIndex, maxResults) {
        const similarApiUrl = 'https://searchserverapi.com/getwidgets?api_key=3R1z2i6V5n&output=jsonp&items=true&maxResults=1000&suggestions=true&suggestionsMaxResults=5&pages=true&pagesMaxResults=10&categories=true&categoryStartIndex=0&categoriesMaxResults=5';
        
        const url_obj = new URL(window.location.href);
        const searchQuery = url_obj.searchParams.get('q') || '';
        
        const response = await fetch(`${similarApiUrl}&q=${encodeURIComponent(searchQuery)}&startIndex=${startIndex}&maxResults=${maxResults}`);
        if (!response.ok) {
            throw new Error('Similar search failed');
        }
        
        return await response.json();
    }
    async trySimilarProducts() {
        try {
            const similarResult = await this.fetchSimilarProducts(this.settings.similarProductStartIndex, this.settings.similarProductItemsPerPage);
            
            if (similarResult.totalItems > 0) {
                this.classList.add('search-similar-products');
                this.showSimilarProducts(similarResult);
            } else {
                this.showNoSimilarProducts();
            }
        } catch (error) {
            this.showNoSimilarProducts();
        }
    }
    showSimilarProducts(result) {
        this.isShowingSimilarProducts = true;
        
        // Store the total count for pagination
        this.settings.similarProductTotalItems = result.totalItems;
        this.settings.similarProductCurrentPage = 0;
        this.settings.similarProductStartIndex = 0;
        
        // Reset loading flag for similar search
        this.settings.isLoading = false;

        // Render the products using existing method
        this.renderProducts(result);

        // Initialize infinite scroll for similar search
        this.initInfiniteScrollLoadMore(result);

        // Initialize Wishlist
        _theme.Wishlist.init();

        // Initialize quick view
        new productPreviewSizes();

        const searchTxt = `Showing similar products for "${this.searchQuery}"`;
        this.selectors.searchResultInfo.setAttribute('aria-label', searchTxt);
    }
    showNoSimilarProducts() {
        this.closest('[data-search-container]').querySelector('[data-sidebar-container]').classList.add('hidden');
        this.closest('[data-search-container]').querySelector('[data-products-container]').classList.add('hidden');
        this.closest('[data-search-container]').querySelector('[data-toolbar-container] .column-right').classList.add('hidden');
        this.closest('[data-search-container]').querySelector('[data-no-search-container]').classList.remove('hidden');

        const imageCardElement = document.querySelector('.image-with-text-card-main-container .search-result-featured-grid');
        if (imageCardElement) imageCardElement.classList.remove('hidden');
    }
    async loadMoreSimilarProducts() {
        try {
            const similarResult = await this.fetchSimilarProducts(this.settings.similarProductStartIndex, this.settings.similarProductItemsPerPage);
            
            if (similarResult.totalItems > 0) {
                this.renderProducts(similarResult);
                // Reinitialize infinite scroll for next batch
                this.initInfiniteScrollLoadMore(similarResult);
                // Reinitialize quickview for new products
                new productPreviewSizes();
            }
            
            this.settings.isLoading = false;
            _theme.toggleLoading(false);
        } catch (error) {
            console.error('Error loading more similar search results:', error);
            this.settings.isLoading = false;
            _theme.toggleLoading(false);
        }
    }

    initInitialEvents(){

        // Show product
        const showItems = Array.from(this.selectors.showList.querySelectorAll('li'));
        showItems.forEach(showItem => {
            showItem.addEventListener('keydown', evt => {
                if(evt.key === "Enter"){
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.stopImmediatePropagation();
                    showItem.click();
                }
                if(evt.key === "Tab"){
                    this.closeShowMenu();
                }
            });

            showItem.addEventListener('click', evt => {
                showItems.filter(item => item !== showItem).forEach(item => {
                    item.setAttribute('aria-selected', false);
                    item.classList.remove('active');
                });
                
                const showLabel = showItem.getAttribute('data-text');
                this.selectors.showBtn.textContent = showLabel;

                showItem.setAttribute('aria-selected', true);
                showItem.classList.add('active');

                this.closeShowMenu();
                this.resetFilters();
                this.fetchProducts(false);
            });
        });

        this.selectors.showBtn.addEventListener('click', (evt) => {
            const isOpen = JSON.parse(this.selectors.showBtn.getAttribute('aria-expanded'));
            if (isOpen) {
                this.closeShowMenu(evt.target);
            } else {
                this.openShowMenu(evt.target);
            }
        });
        this.selectors.showDiv.addEventListener('keyup', evt => {
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();

            let selectedElem = this.selectors.showList.querySelector('li[aria-selected="true"]');
            if(!selectedElem) selectedElem = this.selectors.showList.querySelector('li');

            const target = evt.target;
            const nextElem = selectedElem.nextElementSibling;
            const prevElem = selectedElem.previousElementSibling;

            if(evt.key === "Escape") {
                this.closeShowMenu();
                this.selectors.showBtn.focus();
            }

            if(evt.key === "ArrowUp" && prevElem) {
                evt.preventDefault();
                selectedElem.setAttribute('aria-selected', false);
                prevElem.setAttribute('aria-selected', true);
                prevElem.focus();
            }

            if(evt.key === "ArrowDown" && nextElem) {
                evt.preventDefault();
                selectedElem.setAttribute('aria-selected', false);
                nextElem.setAttribute('aria-selected', true);
                nextElem.focus();
            }

            if(evt.key === "Tab" && !this.selectors.showDiv.contains(target)) {
                this.closeShowMenu();
            }
            
        });

        // Sort by
        const sortByItems = Array.from(this.selectors.sortByList.querySelectorAll('li'));
        sortByItems.forEach(sortItem => {
            sortItem.addEventListener('keydown', evt => {
                if(evt.key === "Enter"){
                    evt.preventDefault();
                    evt.stopPropagation();
                    evt.stopImmediatePropagation();
                    sortItem.click();
                }
                if(evt.key === "Tab"){
                    this.closeSortByMenu();
                }
            });

            sortItem.addEventListener('click', evt => {
                sortByItems.filter(item => item !== sortItem).forEach(item => {
                    item.setAttribute('aria-selected', false);
                    item.classList.remove('active');
                });
                
                const sortLabel = sortItem.getAttribute('data-text');
                this.selectors.sortByBtn.textContent = sortLabel;

                sortItem.setAttribute('aria-selected', true);
                sortItem.classList.add('active');

                this.closeSortByMenu();
                this.resetFilters();
                
                // Only fetch products if not showing similar products
                if (!this.isShowingSimilarProducts) {
                    this.fetchProducts(false);
                }
            });
        });

        this.selectors.sortByBtn.addEventListener('click', (evt) => {

            const isOpen = JSON.parse(this.selectors.sortByBtn.getAttribute('aria-expanded'));
            if(isOpen){
                this.closeSortByMenu(evt.target);
            } else {
                this.openSortByMenu(evt.target);
            }
        });
        this.selectors.sortByDiv.addEventListener('keyup', evt => {
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();

            let selectedElem = this.selectors.sortByList.querySelector('li[aria-selected="true"]');
            if(!selectedElem) selectedElem = this.selectors.sortByList.querySelector('li');

            const nextElem = selectedElem.nextElementSibling;
            const prevElem = selectedElem.previousElementSibling;
            const target = evt.target;

            if(evt.key === "Escape"){
                this.closeSortByMenu();
                this.selectors.sortByBtn.focus();
            }

            if(evt.key === "Tab" && !this.selectors.sortByDiv.contains(target)){
                this.closeSortByMenu();
            }

            if(evt.key === "ArrowDown" && nextElem){
                evt.preventDefault();
                selectedElem.setAttribute('aria-selected', false);
                nextElem.setAttribute('aria-selected', true);
                nextElem.focus();
            }

            if(evt.key === "ArrowUp" && prevElem){
                evt.preventDefault();
                selectedElem.setAttribute('aria-selected', false);
                prevElem.setAttribute('aria-selected', true);
                prevElem.focus();
            }
        });

        // Clear All
        this.selectors.clearAllBtns.forEach(btn => {
            btn.addEventListener('click', evt => {

                const filterInputs = this.selectors.filterContainer.querySelectorAll('[data-filter-option-container] input[type="checkbox"]');
                filterInputs.forEach(input => {
                    input.checked = false;
                });

                this.settings.isPriceFilter = false;
                this.resetFilters();
                this.fetchProducts(false);
            });
        });
        
        document.body.addEventListener('click', evt => {
            const target = evt.target;
            const sortBy = this.querySelector('[data-sortby]');
            if(target !== sortBy && !sortBy.contains(target)){
                this.closeSortByMenu();
            }
            const show = this.querySelector('[data-limited-view]');
            if(target !== show && !show.contains(target)){
                this.closeShowMenu();
            }
        });
    }
    initInfiniteScrollLoadMore(result){
        // Handle similar search pagination
        if (this.isShowingSimilarProducts) {
            const totalItems = this.settings.similarProductTotalItems || result.totalItems;
            const itemsPerPage = this.settings.similarProductItemsPerPage;
            const total_page = Math.ceil(totalItems / itemsPerPage);

            this.settings.similarProductStartIndex = result.startIndex || 0;
            if (this.settings.similarProductCurrentPage >= total_page || totalItems <= itemsPerPage) return;

            const totalLoadedProducts = this.settings.similarProductStartIndex + itemsPerPage;
            if (totalLoadedProducts >= totalItems) return;
        } else {
            // Regular pagination
            const totalItems = result.totalItems;
            const itemsPerPage = result.itemsPerPage;
            const total_page = Math.ceil(totalItems / itemsPerPage);

            this.settings.startIndex = result.startIndex;
            if(this.settings.currentPage >= total_page || totalItems <= itemsPerPage) return;

            const totalLoadedProducts = this.settings.startIndex + itemsPerPage;
            if(totalLoadedProducts >= totalItems) return;
        }

        const viewportBtm = ((window.innerHeight * 40)/100) + 'px';
        const config = {
            root: null,
            rootMargin: `0px 0px ${viewportBtm} 0px`,
            threshold: 0.05
        };

        this.settings.infiniteScrollObserver = new IntersectionObserver((entries, observer) => {
            if(this.settings.isLoading) return;

            if(entries[0].isIntersecting){
                this.settings.isLoadMore = true;
                
                if (this.isShowingSimilarProducts) {
                    // Similar search pagination
                    this.settings.similarProductCurrentPage++;
                    this.settings.similarProductStartIndex = this.settings.similarProductCurrentPage * this.settings.similarProductItemsPerPage;
                } else {
                    // Regular pagination
                    this.settings.currentPage++;
                    this.settings.startIndex = this.settings.currentPage * result.itemsPerPage;
                }

                observer.unobserve(this.selectors.loadMoreBtn);
                this.fetchProducts(false);
            }
        }, config);

        this.settings.infiniteScrollObserver.observe(this.selectors.loadMoreBtn);
    }

    isTimerActive(timerSettings) {
        if (
            !timerSettings.enabled ||
            !timerSettings.startDate ||
            !timerSettings.startTime ||
            !timerSettings.endDate ||
            !timerSettings.endTime
        ) {
            return false;
        }

        // Get current time in EST/EDT
        const currentDateEST = _theme.Helpers.getCurrentESTTime();

        const startDateTime = _theme.Helpers.parseESTDate(timerSettings.startDate, timerSettings.startTime).getTime();
        const endDateTime = _theme.Helpers.parseESTDate(timerSettings.endDate, timerSettings.endTime).getTime();

        const isActive = currentDateEST >= startDateTime && currentDateEST <= endDateTime;

        return isActive;
    }

    buildProductImage(product){
        const featured_image = product.image_link || 'https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
        const image_1 = `<img src="${featured_image}" alt="${product.title} Featured image" class="lazyload" />`;

        let image_2 = '';
        if(product.shopify_images && product.shopify_images.length > 1){
            image_2 = `<div class="images-two"><img src="${product.shopify_images[1]} Secondary image" alt="${product.title}" class="lazyload" /></div>`;

        }

        return { image_1, image_2 };
    }
    buildProductLabels(product){
        
        let priceHtml = '';
        const maxDiscountData = this.getMaxDiscountAndvariant(product);
        const variant = maxDiscountData.maxDiscountVariant;
        let flashVariants = product.shopify_variants.filter((variant) =>
            variant.search_variant_metafields_data && variant.search_variant_metafields_data.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca
        );

        const timerSettings = window.countdownTimerSettings || {};
        const isTimerActive = this.isTimerActive(timerSettings);
        const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

      const flashVariantAvailable = flashVariants[0]?.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca;
      if (flashVariantAvailable && this.collectionHandle.includes('flash-sale') && isTimerActive && flashSaleExtensionActive) {
                const per = Math.round(
                parseFloat(flashVariants[0].list_price) - parseFloat(flashVariants[0].price)
                );
                priceHtml = `<div class="price-regular flash-sale-price" style="display:none;"> 
                    <span class="custom-discount" data-old-price="${flashVariants[0].list_price}" data-current-price="${flashVariants[0].price}">
                        <span class="visually-hidden">$${per} Off</span>
                        <span class="text" aria-hidden="true">
                            <img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/dollar_sign.png?v=1753881211'  alt='' /> 
                            $${per} Off
                        </span>
                    </span>
                </div>`;
        
        }else if(variant && maxDiscountData.maxDiscount) {
            const per = maxDiscountData.maxDiscount;
            priceHtml = `<div class="new-tag-style tag-up-to-off">Up to $${per} Off</div>`;
        }

        let offerHtml = '';
        let offerCount = 1;
        const productTags = product.tags;

        // Check if timer is active and shop metafield is active
        if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
            offerCount = 2;
            const startDate = timerSettings.startDate || '';
            const startTime = timerSettings.startTime || '';
            const endDate = timerSettings.endDate || '';
            const endTime = timerSettings.endTime || '';

            offerHtml = `<div class='offer-tag-style flash-sale' role='status' aria-label='Flash sale promotion'><span class=''>Flash Sale</span> <span class='flash-separator' aria-hidden='true'></span> <countdown-timer data-start-date='${startDate}' data-start-time='${startTime}' data-end-date='${endDate}' data-end-time='${endTime}' data-replace-days-with-hours='${window.replace_days_with_hours}' data-location='product-grid' role='timer' aria-live='polite' aria-label='Flash sale countdown timer' tabindex='0'><span class='flash-timer-text'>00:00:00</span></countdown-timer></div>`;
        }else{
            if(productTags && productTags !== ''){
                const tagsStr = productTags.trim().toLowerCase();
                if (offerCount < 2 && tagsStr.includes('online-only-item')) {
                    offerCount = 2
                    offerHtml = `<div class='new-tag-style tag-online-only'>Online Only</div>`
                
                } else if (offerCount < 2 && tagsStr.includes('best-sellers')) {
                    offerCount = 2
                    offerHtml = `<div class='new-tag-style tag-best-seller'>Best Seller</div>`
                
                }
            }
        }
        

        return (priceHtml !== '' || offerHtml !== '') ? `<div class="product-tags-wrap product-tags-only">${priceHtml}${offerHtml}</div>` : '';
    }

    buildProductLabelsBogo(product){
        let html = '';
        let labelAdded = false; 
        const productTags = product.tags;
        if(!productTags || productTags == '') return '';

        const tags = productTags.split('[:ATTR:]');

        // Check if product has applicable offer metafield (Searchanise format)
        const productOffer = product.metafield_b9ba57cd478d42c60429674e481c50c1;
        
        // Check if variant metafield structure exists
        const hasMetafieldStructure = product.shopify_variants?.some(
            variant => variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
        );

        // Check if any variant has is_offer_applicable = "true" (string) AND available !== "0"
        const hasOfferVariant = hasMetafieldStructure && product.shopify_variants?.some(
            v => v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" && v.available !== "0"
        );

        // Filter variants that have flash sale metafield with value 'true' and are available
        const flashVariants = product.shopify_variants.filter(
            (variant) => variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' && variant.available !== '0'
        );
        
        if (flashVariants.length === 0) {
            // Use metafields for BOGO offers and "3 For $99"
            if (productOffer && hasOfferVariant && !labelAdded) {
                if (productOffer === 'BOGO 30') {
                    labelAdded = true;
                    html += `<a class="promoAnchor product-label" href="/collections/bogo-30" aria-label="BOGO 30 - Mix & Match">
                                <p class="customOff new">BOGO <strong>30</strong> - Mix & Match</p>
                            </a>`;
                } else if (productOffer === 'BOGO 50') {
                    labelAdded = true;
                    html += `<a class="promoAnchor product-label" href="/collections/bogo-50" aria-label="BOGO 50 - Mix & Match">
                                <p class="customOff new">BOGO <strong>50</strong> - Mix & Match</p>
                            </a>`;
                } else if (productOffer && productOffer.includes(' For $')) {
                    const offerParts = productOffer.split(' For $');
                    if (offerParts.length === 2) {
                        const offerQuantity = offerParts[0].trim();
                        const offerPrice = offerParts[1].trim();
                        labelAdded = true;
                        html += `<a class="promoAnchor product-label" href="/collections/3-for-99-perfumes-and-colognes">
                                    <p class="customOff new">Buy ${offerQuantity} for $${offerPrice} | Mix & Match</p>
                                </a>`;
                    }
                }
            }

            // Check legacy tags for "Bundle Deals" (keep existing tag logic)
            if (!labelAdded) {
                tags.map(function(tag) {
                    if (labelAdded) return;
                    
                    const tag_dcase = tag.trim().toLowerCase();
                    if(tag_dcase.indexOf('BundleDeal') > -1 || tag_dcase.indexOf('bundle-save') > -1){
                        labelAdded = true;
                        html += `<a class="promoAnchor product-label" href="/collections/bundle-save">
                                    <p class="customOff new">Bundle Deals</p>
                                </a>`;
                    }
                });
            }
        }

        return html;
    }
    buildProductPrice(product){
        let html = '';
        const isAvailable = this.isProductAvailable(product);
        const variant = this.getFirstAvailableVariant(product);

        // Check for flash sale variants
        let flashVariants = '';
        flashVariants = product.shopify_variants.filter((variant) =>
            variant.search_variant_metafields_data && variant.search_variant_metafields_data.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca
        );

        if(variant) {
            let price = Shopify.formatMoney((variant.price * 100), window.money_format);
            let cprice = Shopify.formatMoney((variant.list_price * 100), window.money_format);

            if (parseFloat(variant.list_price) > parseFloat(variant.price)) {
                html = `<div class="price-list">
                            <span class="visually-hidden visually-hidden--inline">Sale Price</span>
                            ${price}
                            <span class="visually-hidden">Regular Price</span>
                            <span class="del-price" aria-hidden="false">${cprice}</span>
                        </div>`;
            } else {
                html = `<div class="price-list">
                            <span class="visually-hidden visually-hidden--inline">Sale Price</span>
                            ${price}
                        </div>`;
            }
        }

        let prices = product.shopify_variants.map(function(v){ return Number(v.price); });
        if(prices.length > 1) {
            const min_price = Math.min.apply(null, prices);
            const max_price = Math.max.apply(null, prices);

            if(min_price !== max_price) {
                const min_price_formatted = Shopify.formatMoney((min_price*100), window.money_format);
                const max_price_formatted = Shopify.formatMoney((max_price*100), window.money_format);
                html =  `<div class="price-list">
                            <span class="visually-hidden">Price range from ${min_price_formatted} to ${max_price_formatted}</span> 
                            <span aria-hidden="true">${min_price_formatted} - ${max_price_formatted}</span>
                        </div>`;
            }
        }

        // Add flash sale price display
        const flashVariantAvailable = flashVariants[0]?.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca;
        if (flashVariantAvailable && this.collectionHandle && this.collectionHandle.includes('flash-sale')) {
            const flashVariant = flashVariants[0];
            const discount = Math.round(
                parseFloat(flashVariant.list_price) - parseFloat(flashVariant.price)
            );
            html += `<div class="price-regular flash-sale-price" style="display:none;"> 
                <span class="custom-discount" data-old-price="${flashVariant.list_price}" data-current-price="${flashVariant.price}">
                    <span class="visually-hidden">$${discount} Off</span>
                    <span class="text" aria-hidden="true">
                        <img src='https://cdn.shopify.com/s/files/1/0269/7763/2389/files/dollar_sign.png?v=1753881211'  alt='' /> 
                        $${discount} Off
                    </span>
                </span>
            </div>`;
        }

        if(!isAvailable) html = '';
        return html;
    }
    buildProductQvAtcBtnMob(product) {
        let html = '';
      
        if (product.shopify_variants.length > 1) {
            html = `<button type="button" class="btn preview-size-btn hide-in-desk" aria-label="Quick look for ${product.title}" data-preview-size-mob-btn>
                        <span>Quick View</span>
                    </button>`;
        } else {
            html = `<button type="button" class="btn preview-atc-btn hide-in-desk" aria-label="Add To Cart ${product.title}">
                        <span>Add To Cart</span>
                    </button>
                    <span class="visually-hidden addedMessageBundleText"  role="status" aria-live="polite" data-aria-live ></span>`;
        }
        
        return html;
    }
    buildProductQvAtcBtnDesk(product) {
        let html = '';
        
        if (product.shopify_variants.length > 1) {
            html = `<button type="button" class="btn preview-size-btn quickview-button hide-in-mob" aria-label="Quick view for ${product.title}" data-preview-size-btn>
                        <span>Quick View</span>
                    </button>`;
        } else {
            html = `<button type="button" class="btn preview-atc-btn quickview-button hide-in-mob" aria-label="Add To Cart ${product.title}">
                        <span>Add To Cart</span>
                    </button>
                    <span class="visually-hidden addedMessageBundleText hide-in-mob"  role="status" aria-live="polite" data-aria-live ></span>`;
        }
    
        return html;
    }

    buildProductPriceOffer(product){
        let html = '';
        const isAvailable = this.isProductAvailable(product);
        let variant = this.getFirstAvailableVariant(product);

        let flashVariants = product.shopify_variants.filter((variant) =>
            variant.search_variant_metafields_data && variant.search_variant_metafields_data.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca
        );

        const timerSettings = window.countdownTimerSettings || {};
        const isTimerActive = this.isTimerActive(timerSettings);
        const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

        const flashVariantAvailable = flashVariants[0]?.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca;

        if (flashVariantAvailable && isTimerActive && flashSaleExtensionActive) {
          variant = flashVariants[0];
        }
        if(variant) {
            let priceHtml  = '';
            let price = Shopify.formatMoney((variant.price * 100), window.money_format);
            let cprice = Shopify.formatMoney((variant.list_price * 100), window.money_format);
            

            if (parseFloat(variant.list_price) > parseFloat(variant.price)) {
                priceHtml = `<div class="price price--on-sale">
                                <div class="price__container">
                                    <div class="price__sale">
                                        <span>
                                            <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                            <span class="price-item price-item--sale price-item--last" data-salepricenew="">${price}</span>
                                        </span>
                                        <span>
                                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                            <span class="price-item price-item--regular" data-salepriceold="">${cprice}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>`;
            } else {
                priceHtml = `<div class="price">
                                <div class="price__container">
                                    <div class="price__regular">
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span class="price-item price-item--regular" data-regularprice="">${price}</span>
                                    </div>
                                </div>
                            </div>`;
            }
            
            html = `<div class="price-list offer-grid-price-list">
                        <div class="offer-varient-container">
                            <div class="feature-product-sale">
                                ${priceHtml}
                            </div>
                            <div class="offer-varient-size" data-id="${variant.variant_id}">
                                <span>
                                    <span class="offer-varient-size-title">Size: </span>
                                    <span class="offer-varient-size-value">${variant.options.Size}</span>
                                </span>
                            </div>
                        </div>
                    </div>`;
        }

        if(!isAvailable) html = '';
        return html;
    }
    buildProductQvBtnDeskOffer(product) {
        let html = '';
        let flashVariants = product.shopify_variants.filter((variant) =>
            variant.search_variant_metafields_data && variant.search_variant_metafields_data.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca
        );

        const timerSettings = window.countdownTimerSettings || {};
        const isTimerActive = this.isTimerActive(timerSettings);
        const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

        const flashVariantAvailable = flashVariants[0]?.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca;
        let variantId = '';
        if (flashVariantAvailable && isTimerActive && flashSaleExtensionActive) {
          variantId = flashVariants[0].variant_id;
        }

        html = `<a class="quickview-button" href="javascript:void(0)" role="button" data-var-id="${variantId}" aria-label="Quick View for ${product.title}" data-id="${this.productHandle}">
                    <span>Quick View</span>
                </a>`;
      
        return html;
    }
    buildProductQvAtcBtnMobOffer(product){
        let html = '';
        let extraClass = '';
        const isAvailable = this.isProductAvailable(product);
        let variant = this.getFirstAvailableVariant(product);

        const timerSettings = window.countdownTimerSettings || {};
        const isTimerActive = this.isTimerActive(timerSettings);
        const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;

        const flashVariants = product.shopify_variants.filter((variant) =>
            variant.search_variant_metafields_data && variant.search_variant_metafields_data.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca
        );

        const flashVariantAvailable = flashVariants[0]?.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca;
        if (flashVariantAvailable && isTimerActive && flashSaleExtensionActive) {
            extraClass = ' mb-3';
            variant = flashVariants[0];
        }
      
        if(isAvailable) {
            html = `<span class="variant cmVariant" style="display:none" data-id="${variant.variant_id}"></span>
                    <div class="d-flex justify-content-between justify-content-lg-center mb-2${extraClass}">
                        <button type="button" aria-label="Add To Cart" class="cm-add-bndle-pro offer-cta-btn aa btn">
                            <span>Add To Cart</span>
                        </button>
                        <button type="button" data-id="qv-${product.title}" data-var-id="${variant.variant_id}" data-url="${product.link}" class="fbt-quickview rounded d-lg-none" data-sidecartqv aria-label="Quick view for ${product.title}"> 
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                <path d="M15 12c0 1.654-1.346 3-3 3s-3-1.346-3-3 1.346-3 3-3 3 1.346 3 3zm9-.449s-4.252 8.449-11.985 8.449c-7.18 0-12.015-8.449-12.015-8.449s4.446-7.551 12.015-7.551c7.694 0 11.985 7.551 11.985 7.551zm-7 .449c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5 5-2.243 5-5z"/>
                            </svg>
                        </button>
                    </div>`;
        } else {
            html = `<button type="button" class="btn disabled" disabled>Sold Out</button>`;
        }
        
        return html;
    }

    buildPrevProductImage(product) {
        let firstAvailableFound = false;
        let firstAvailableVariant = null;

        if (product.shopify_variants && product.shopify_variants.length > 0) {
          firstAvailableVariant = product.shopify_variants.find(variant => variant.available === "1" && !firstAvailableFound);
        }

        if(firstAvailableVariant != null || firstAvailableVariant != undefined) {
          var image = `<img src="${product.image_link}" class="lazyload" data-feauredImage alt="${product.title}" height="115" width="115">`; 
        } else {
          var image = `<img src="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif" class="lazyload" data-feauredImage alt="${product.title}" height="115" width="115">`;
        }
        return image;
    }
    buildPrevProductPrice(product) {
        let html = '';
        let firstAvailableFound = false;
        let firstAvailableVariant = null;

        if (product.shopify_variants && product.shopify_variants.length > 0) {
          firstAvailableVariant = product.shopify_variants.find(variant => variant.available === "1" && !firstAvailableFound);
        }

        if(firstAvailableVariant != null || firstAvailableVariant != undefined) {

            const price = Shopify.formatMoney((firstAvailableVariant.price*100), window.money_format);
            const list_price = Shopify.formatMoney((firstAvailableVariant.list_price*100), window.money_format);

            const discount = parseFloat(firstAvailableVariant.list_price) - parseFloat(firstAvailableVariant.price);
            const discountPercentage = (discount * 100) / parseFloat(firstAvailableVariant.list_price);

            html = `<div class="price price--large ${product ? 'price--sold-out' : ''} ${firstAvailableVariant.list_price > firstAvailableVariant.price ? 'price--on-sale' : 'price-not-on-sale'} price--show-badge">
                        <div class="price__container">
                        <div class="price__regular">
                            <span class="visually-hidden visually-hidden--inline">Regular price</span>
                            <span class="price-item price-item--regular" data-regularPrice>${price}</span>
                        </div>
                        <div class="price__sale">
                            ${firstAvailableVariant.list_price > firstAvailableVariant.price 
                            ?
                            `<span>
                                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                <span class="price-item price-item--sale price-item--last" data-salePriceNew>${price}</span>
                            </span>
                            <span>
                                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                <span class="price-item price-item--regular" data-salePriceOld>${list_price}</span>
                            </span>`
                            : ''
                            }
                        </div>
                        </div>
                        ${firstAvailableVariant.list_price > firstAvailableVariant.price
                        ?
                        `<div class="label-sale-bg">
                            <p>
                            <span class="upto-minus" aria-hidden="true"></span>
                            <span data-perDiscount>${Math.round(discountPercentage)}% off</span>
                            <span class="visually-hidden visually-hidden--inline"> </span><span class="upto-end"></span>
                            </p>
                        </div>`
                        : ''
                        }
                    </div>`; 
        }
        return html;
    }
    buildPrevProductDescription(product){
        let html = '';

        if(product.metafield_39a415b7072467729daf6733243f33ab != undefined && product.metafield_39a415b7072467729daf6733243f33ab != ''){
          html += `<div class="notes_details">
                    <span class="notes_label">Top Notes:</span>
                    <span class="notes_content">${product.metafield_39a415b7072467729daf6733243f33ab}</span>
                  </div>`;
        }
        if(product.metafield_b0ffc99d1405a524fad2ad2e3a315ce6 != undefined && product.metafield_b0ffc99d1405a524fad2ad2e3a315ce6 != ''){
          html += `<div class="notes_details">
                    <span class="notes_label">Middle Notes:</span>
                    <span class="notes_content">${product.metafield_b0ffc99d1405a524fad2ad2e3a315ce6}</span>
                  </div>`;
        }
        if(product.metafield_694d3c8ce0abadb3108419a592870435 != undefined && product.metafield_694d3c8ce0abadb3108419a592870435 != ''){
          html += `<div class="notes_details">
                    <span class="notes_label">Base Notes:</span>
                    <span class="notes_content">${product.metafield_694d3c8ce0abadb3108419a592870435}</span>
                  </div>`;
        }
        if (product.description && product.description !== '') { 
          let truncatedDesc = product.description.length > 160 ? product.description.substring(0, 160) + "..." : product.description;
      
          html += `<div class="product__description" data-description>
                    <div data-description-short>
                      ${truncatedDesc} 
                      ${product.description.length > 160 ? '<a href="#" role="button" data-description-readmore>Read More <span aria-hidden="true">&#62;&#62;</span></a>' : ''}
                    </div>
                    <div data-description-full style="display: none;">
                      ${product.description}
                      <a href="#" role="button" data-description-readless><span aria-hidden="true">&#60;&#60;</span> Read Less</a>
                    </div>
                  </div>`;
        }
        if (html != '') { 
          html = `<h2 class="font-weight-bold" style="font-size: 15px;">Description</h2> ${html}`;
        }
        
        return html;
    }
    buildPrevProductAtcBtn(product) {
        let html = '';
        let firstAvailableFound = false;
        let firstAvailableVariant = null;

        if (product.shopify_variants && product.shopify_variants.length > 0) {
          firstAvailableVariant = product.shopify_variants.find(variant => variant.available === "1" && !firstAvailableFound);
        }

        if(firstAvailableVariant != null || firstAvailableVariant != undefined) {

          const price = Shopify.formatMoney((firstAvailableVariant.price*100), window.money_format);
          const list_price = Shopify.formatMoney((firstAvailableVariant.list_price*100), window.money_format);

          html = `<span>Add To Cart</span>
                  <span>${price}</span>
                  <span>${list_price > price ? list_price : ''}</span>
                  <span class="visually-hidden">Add To Cart ${product.title} Sale Price ${price}</span>`;
        }
        return html;
    }
    buildPrevProductSelectOptions(product){
        let html = '';
        let firstAvailableFound = false;
        let firstAvailableVariant = null;

        if (product.shopify_variants && product.shopify_variants.length > 0) {
          firstAvailableVariant = product.shopify_variants.find(variant => variant.available === "1" && !firstAvailableFound);
        }

        if(firstAvailableVariant != null || firstAvailableVariant != undefined) {
          const availableVarQty = parseInt(firstAvailableVariant.quantity_total, 10) || 0;
          for (let i = 1; i <= 10; i++) {
              html += `<option value="${i}" ${i > availableVarQty ? 'disabled' : ''}>${i}</option>`;
          }
        }

        return html;
    }
    buildPrevProductVariantsJSON(product){
        let variantArray = [];
        let html = '<script type="application/json" data-variantJSON>[[product_variants_json]]</script>';

        if (product.shopify_variants && product.shopify_variants.length > 0) {
          product.shopify_variants.forEach(function (variant) {
            variantArray.push({
              "id": Number(variant.variant_id),
              "title": variant.options.Size,
              "option1": variant.options.Size,
              "option2": null,
              "option3": null,
              "sku": variant.sku,
              "taxable": variant.taxable === "1" ? true : false,
              "featured_image": variant.image_link ? { "src": variant.image_link } : null,
              "available": variant.available === "1" ? true : false,
              "name": variant.image_alt,
              "public_title": variant.options.Size,
              "options": [`${variant.options.Size}`],
              "price": Math.round(parseFloat(variant.price) * 100),
              "compare_at_price": Math.round(parseFloat(variant.list_price) * 100),
              "inventory_quantity": Number(variant.quantity_total),
              "barcode": variant.barcode
            });
          });
        }
        html = html.replace('[[product_variants_json]]', JSON.stringify(variantArray));
        return html;
    }
    buildPrevProductVariantListMobile(product, device) {
        let li = '';
        let html = '';
        let legend = '';
        let availableFound = false;
      
        if(product.shopify_variants && product.shopify_variants.length > 0) {
          product.shopify_variants.forEach(function (variant) {

            let isChecked = !availableFound && variant.available === "1";
            availableFound ||= isChecked;

            let size = variant.options.Size;
            let price = Shopify.formatMoney((variant.price*100), window.money_format);

            if(size) {
              if (size.includes('oz')) { size = size.replace('oz.', 'OZ').replace('oz', 'OZ'); }

              const ozValue = 29.5735;
              const unitConvertArr = variant.options.Size.split('oz');
              const selectedVal  = variant.options.Size;
              let updateSize;
              let selectedValSliced;
              if(variant.options.Size.includes('oz')){
                selectedValSliced = selectedVal.slice(0,selectedVal.length - 1);
              } else {
                selectedValSliced = selectedVal.slice(0,selectedVal.length);
              } 
              if(selectedVal.includes('Tester')){
                let selectedValArr = selectedVal.split("Tester");
                selectedValSliced = selectedValArr[0].slice(0,selectedValArr[0].length - 2);
                selectedValSliced  = selectedValSliced + " Tester";
              }
              const unitConvertArrValue = Number(unitConvertArr[0]);
              const conversions = { 0.05: 1.5,0.17: 5,0.5: 15,0.8: 25,1.0: 30,1.4: 40,1.7: 50,2.0: 60,2.5: 75,2.7: 80,3.0: 90,3.3: 100,3.4: 100,4.2: 125,5.0: 150,6.7: 200, };
              const unitValue = conversions[unitConvertArrValue] || Math.floor(ozValue * unitConvertArrValue);
              
              if(variant.options.Size.includes('oz')){ 
                updateSize = `${selectedValSliced} / ${unitValue}ml`
              } else {
                updateSize = `${selectedValSliced}`
              }
              
              li += `<li>
                        <input type="radio" name="Size" class="select-variant" value="${variant.options.Size}" id="${device}-${product.product_id}-${variant.variant_id}" 
                          ${variant.available === "0" ? `aria-describedby="status-${device}-${product.product_id}-${variant.variant_id}"` : ""} ${isChecked ? "checked" : ""}
                        >
                        <label title="${updateSize}" class="size-label ${variant.available === "0" ? 'disabled' : ''}" for="${device}-${product.product_id}-${variant.variant_id}" ${variant.available === "0" ? 'aria-disabled="true"' : ''} > 
                          <span class="size-title">${size}</span>
                          <span class="size-value">${price}</span>
                          ${variant.available === "0" ? `<span class="visually-hidden" id="status-${device}-${product.product_id}-${variant.variant_id}">Sold out</span>` : ""}
                        </label>
                      </li>`;
            }

          });
        }

        if(device == 'mobile') {
          legend = `<legend>
                      <span class="font-weight-bold">Select Size</span> 
                      <span aria-hidden="true"> | </span> 
                      <span class="font-weight-bold">${product.shopify_variants.length} Variants</span>
                    </legend>`;
        }
      
        if(li !== '') {
          html = `<custom-variant-radios data-id="${product.product_id}" data-handle="${product.link.replace('/products/','')}">
                    <fieldset class="js product-form__input">
                      ${legend}
                      <ul class="variant-list" role="none">${li}</ul>
                    </fieldset>
                  </custom-variant-radios>`;
        }
        return html;
    }
    buildPrevProductVariantListDesktop(product, device) {
        let ul = '';
        let li = '';
        let html = '';
        let legend = '';
        let availableFound = false;
        let has_tester_variant = false;
      
        if(product.shopify_variants && product.shopify_variants.length > 0) {
          product.shopify_variants.forEach(function (variant) {
            if(variant.options.Size != undefined) {
              if(!variant.options.Size.includes('Tester')) {
                let isChecked = !availableFound && variant.available === "1";
                availableFound ||= isChecked;

                let size = variant.options.Size;
                let price = Shopify.formatMoney((variant.price*100), window.money_format);

                if(size) {
                  if (size.includes('oz')) { size = size.replace('oz.', 'OZ').replace('oz', 'OZ'); }

                  const ozValue = 29.5735;
                  const unitConvertArr = variant.options.Size.split('oz');
                  const selectedVal  = variant.options.Size;
                  let updateSize;
                  let selectedValSliced;
                  if(variant.options.Size.includes('oz')){
                    selectedValSliced = selectedVal.slice(0,selectedVal.length - 1);
                  } else {
                    selectedValSliced = selectedVal.slice(0,selectedVal.length);
                  } 
                  const unitConvertArrValue = Number(unitConvertArr[0]);
                  const conversions = { 0.05: 1.5,0.17: 5,0.5: 15,0.8: 25,1.0: 30,1.4: 40,1.7: 50,2.0: 60,2.5: 75,2.7: 80,3.0: 90,3.3: 100,3.4: 100,4.2: 125,5.0: 150,6.7: 200, };
                  const unitValue = conversions[unitConvertArrValue] || Math.floor(ozValue * unitConvertArrValue);
                  
                  if(variant.options.Size.includes('oz')){ 
                    updateSize = `${selectedValSliced} / ${unitValue}ml`
                  } else {
                    updateSize = `${selectedValSliced}`
                  }
                  
                  li += `<li>
                            <input type="radio" name="Size" class="select-variant" value="${variant.options.Size}" id="${device}-${product.product_id}-${variant.variant_id}" 
                              ${variant.available === "0" ? `aria-describedby="status-${device}-${product.product_id}-${variant.variant_id}"` : ""} ${isChecked ? "checked" : ""}
                            >
                            <label title="${updateSize}" class="size-label ${variant.available === "0" ? 'disabled' : ''}" for="${device}-${product.product_id}-${variant.variant_id}" ${variant.available === "0" ? 'aria-disabled="true"' : ''} > 
                              <span class="labelValue">${updateSize}</span>
                              ${variant.available === "0" ? `<span class="visually-hidden" id="status-${device}-${product.product_id}-${variant.variant_id}">Sold out</span>` : ""}
                            </label>
                          </li>`;
                }
              } else {
                has_tester_variant = true;
              }
            }
          });
          ul += `<div class="variant-text mt-1">Standard Size</div><ul class="variant-list" role="none">${li}</ul>`; 

          
          if(has_tester_variant) {
            li = '';
            product.shopify_variants.forEach(function (variant) {
              if(variant.options.Size != undefined) {
                if(variant.options.Size.includes('Tester')) {
                  let isChecked = !availableFound && variant.available === "1";
                  availableFound ||= isChecked;

                  let size = variant.options.Size;
                  let price = Shopify.formatMoney((variant.price*100), window.money_format);

                  if(size) {
                    if (size.includes('oz')) { size = size.replace('oz.', 'OZ').replace('oz', 'OZ'); }

                    const ozValue = 29.5735;
                    const unitConvertArr = variant.options.Size.split('oz');
                    const selectedVal  = variant.options.Size;
                    let updateSize;
                    let selectedValSliced;
                    if(variant.options.Size.includes('oz')){
                      selectedValSliced = selectedVal.slice(0,selectedVal.length - 1);
                    } else {
                      selectedValSliced = selectedVal.slice(0,selectedVal.length);
                    } 
                    if(selectedVal.includes('Tester')){
                      let selectedValArr = selectedVal.split("Tester");
                      selectedValSliced = selectedValArr[0].slice(0,selectedValArr[0].length - 2);
                      selectedValSliced  = selectedValSliced;
                    }
                    const unitConvertArrValue = Number(unitConvertArr[0]);
                    const conversions = { 0.05: 1.5,0.17: 5,0.5: 15,0.8: 25,1.0: 30,1.4: 40,1.7: 50,2.0: 60,2.5: 75,2.7: 80,3.0: 90,3.3: 100,3.4: 100,4.2: 125,5.0: 150,6.7: 200, };
                    const unitValue = conversions[unitConvertArrValue] || Math.floor(ozValue * unitConvertArrValue);
                    
                    if(variant.options.Size.includes('oz')){ 
                      updateSize = `${selectedValSliced} / ${unitValue}ml`
                    } else {
                      updateSize = `${selectedValSliced}`
                    }
                    
                    li += `<li>
                              <input type="radio" name="Size" class="select-variant" value="${variant.options.Size}" id="${device}-${product.product_id}-${variant.variant_id}" 
                                ${variant.available === "0" ? `aria-describedby="status-${device}-${product.product_id}-${variant.variant_id}"` : ""} ${isChecked ? "checked" : ""}
                              >
                              <label title="${updateSize}" class="size-label ${variant.available === "0" ? 'disabled' : ''}" for="${device}-${product.product_id}-${variant.variant_id}" ${variant.available === "0" ? 'aria-disabled="true"' : ''} > 
                                <span class="labelValue">${updateSize}</span>
                                ${variant.available === "0" ? `<span class="visually-hidden" id="status-${device}-${product.product_id}-${variant.variant_id}">Sold out</span>` : ""}
                              </label>
                            </li>`;
                  }
                }
              }
            });
            ul += `<div class="variant-text mt-1">Tester Size</div><ul class="variant-list" role="none">${li}</ul>`;
          }
        }
      
        if(li !== '') {
          html = `<custom-variant-radios data-id="${product.product_id}" data-handle="${product.link.replace('/products/','')}">
                    <fieldset class="js product-form__input">
                      ${legend}
                      ${ul}
                    </fieldset>
                  </custom-variant-radios>`;
        }
        return html;
    }
    
    buildNotifyMeBtn(product){
        let html = '';
        const isAvailable = this.isProductAvailable(product);
    
        if (!isAvailable) {
            let notifyHTML = _theme.product_html.notify_me;
            notifyHTML = _theme.Helpers.updateHtml(notifyHTML, '[[notify_me_product_id]]', product.product_id);
            html = notifyHTML;
        }
        return html;
    }
    buildGridClass(product) {
        let html = '';
        const isAvailable = this.isProductAvailable(product);
    
        html = isAvailable ? 'available' : 'sold_out';
        return html;
    }
    updateSRStatus(){
        if(this.settings.isLoading){
            this.selectors.srStatus.textContent = "Content is loading";
        } else {
            this.selectors.srStatus.textContent = "Content loaded successfully";
        }
    } 

    isProductAvailable(product) {
        // Check if any variant is available (not "0")
        let isAvailable = product.shopify_variants.some(function(variant) {
            return variant.available !== "0"; // Return true if available
        });
    
        // Return true or false based on the availability
        return isAvailable ? true : false;
    }
    getGwpProperties(product) {
        let html = '';
        if (!product) return;

        // Check if any variant has the metafield structure first
        const hasMetafieldStructure = product.shopify_variants?.some(
            (variant) => variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
        );

        if (hasMetafieldStructure) {
            // Find variant with is_offer_applicable = true using Searchanise metafield structure
            const offerVariant = product.shopify_variants?.find(
                v => v.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true"
            );

            if (offerVariant) {
                html += `<input type="hidden" name="properties[_bundleVarId]" value="${offerVariant.variant_id}" data-bundleVarId>`;
            }
        }
        return html;
    }
    getFirstAvailableVariant(product) {

        // Filter variants that have flash sale metafield with value 'true' and are available
        const flashVariants = product.shopify_variants.filter(
          (variant) =>
            variant.search_variant_metafields_data?.variant_metafield_7196e689a0a0c382ce7f6b23dbe610ca === 'true' &&
            variant.available !== '0'
        );
        
        const timerSettings = window.countdownTimerSettings || {};
        const isTimerActive = this.isTimerActive(timerSettings);
        const flashSaleExtensionActive = timerSettings.flashSaleExtensionActive === true;
  
        // Check if any flash variant exists
        if (flashVariants.length > 0 && isTimerActive && flashSaleExtensionActive) {
            const bundleIdVariant = flashVariants[0];

            // Find the first variant that is available (not "0")
            const availableVariant = product.shopify_variants.find(
                (variant) => variant.available !== '0'
            );
    
            return bundleIdVariant || availableVariant || product.shopify_variants[0];
        } else {
    
            // Check if any variant has the metafield structure first
            const hasMetafieldStructure = product.shopify_variants?.some(
                (variant) => variant.search_variant_metafields_data?.hasOwnProperty('variant_metafield_25c7b979d6abf42fb11a9be16739134f')
            );
    
            if (hasMetafieldStructure && this.settings.renderOfferTemplate) {
                // Find variant with is_offer_applicable = true that is available
                const bundleIdVariant = product.shopify_variants.find(
                    (variant) => variant.search_variant_metafields_data?.variant_metafield_25c7b979d6abf42fb11a9be16739134f === "true" && variant.available !== '0'
                );
    
                // Find the first variant that is available (not "0")
                const availableVariant = product.shopify_variants.find(
                    (variant) => variant.available !== '0'
                );
    
                return bundleIdVariant || availableVariant || product.shopify_variants[0];
            } else {
                // Find the first variant that is available (not "0")
                const availableVariant = product.shopify_variants.find(
                    (variant) => variant.available !== '0'
                );
    
                // If no variant is available, return the first variant
                return availableVariant || product.shopify_variants[0];
            }
        }
    }
    getMaxDiscountAndvariant(product){
        let maxDiscount = 0, maxDiscountVariant = null;
        let availableMaxDiscount = 0, availableMaxDiscountVariant = null;

        product.shopify_variants && product.shopify_variants.length > 0 && product.shopify_variants.forEach(function(v) {
            const maxPrice = Number(v.list_price);
            if(!maxPrice || maxPrice <= 0) return false;

            const price = Number(v.price);
            const discountPer = Math.ceil(((maxPrice - price)));

            if(discountPer > maxDiscount) {
                maxDiscount = discountPer;
                maxDiscountVariant = v;
            }
            if(discountPer > availableMaxDiscount && Number(v.available)){
                availableMaxDiscount = discountPer;
                availableMaxDiscountVariant = v;
            }
        });

        const discountAmt = Number(product.discount);
        const productListPrice = Number(product.list_price);

        if(!maxDiscount && discountAmt > 0 && productListPrice > 0) {
            const per = Math.floor(((product.list_price - product.price)));
            maxDiscount = discountAmt || per;
        }

        return {
            maxDiscount: maxDiscount,
            maxDiscountVariant: maxDiscountVariant,
            availableMaxDiscount: availableMaxDiscount,
            availableMaxDiscountVariant: availableMaxDiscountVariant
        }
    }
    
    // Show product
    openShowMenu(){
        this.selectors.showList.style.display = "block";
        this.selectors.showBtn.setAttribute('aria-expanded', true);
        
        const showMenuActiveItem = this.selectors.showList.querySelector('.active[aria-selected="true"]');
        if(showMenuActiveItem) {
            showMenuActiveItem.focus();
        }
    }
    closeShowMenu(){
        this.selectors.showList.style.display = "none";
        this.selectors.showBtn.setAttribute('aria-expanded', false);
        
        // const selectedCurrent = this.selectors.showList.querySelector('.selected-current');
        // if(selectedCurrent) selectedCurrent.classList.remove('selected-current');
    }

    // Sortby product
    openSortByMenu(){
        this.selectors.sortByList.style.display = "block";
        this.selectors.sortByBtn.setAttribute('aria-expanded', true);

        const sortMenuActiveItem = this.selectors.sortByList.querySelector('.option-current[aria-selected="true"]');
        if(sortMenuActiveItem) {
            sortMenuActiveItem.focus();
        }
    }
    closeSortByMenu(){
        this.selectors.sortByList.style.display = "none";
        this.selectors.sortByBtn.setAttribute('aria-expanded', false);

        // const selectedCurrent = this.selectors.sortByList.querySelector('.selected-current');
        // if(selectedCurrent) selectedCurrent.classList.remove('selected-current');
    }

    // Sidebar Filter
    openMobSidebarFilter(target){
        this.querySelector('[data-mobile-filter]').style.visibility = 'visible';
        this.querySelector('[data-mobile-filter]').style.transform = 'translate(0)';
        this.selectors.overlay.classList.add('active');

        // _theme.focusTrap($('.sidebar-mob'),function(e) {
        //     this.closeMobSidebarFilter();
        //     target.focus();
        // });
    }
    closeMobSidebarFilter(){
        this.querySelector('[data-mobile-filter]').style.visibility = 'hidden';
        this.querySelector('[data-mobile-filter]').style.transform = 'translate(-100%)';
        this.selectors.overlay.classList.remove('active');
    }
    
}
customElements.define('searchanize-products',SearchanizeProducts)


class productPreviewSizes {
    constructor() {

        this.defaultColl = document.querySelector('searchanize-products.default-collection') || document.querySelector('searchanize-products.search-result-wrapper');
        if (!this.defaultColl) return;
    
        this.removeExistingListeners();
        this.initializeEventListeners();
        if (!window.previewSizesEscapeHandler) {
            window.previewSizesEscapeHandler = true;
            document.addEventListener('keydown', this.handleKeyPress.bind(this));
        }
    }
  
    removeExistingListeners() {
        const existingElements = this.defaultColl.querySelectorAll('[data-preview-size-btn], [data-preview-close-btn], [data-preview-size-mob-btn], [data-preview-close-mob-btn]');
        existingElements.forEach(element => {
            element.removeEventListener('click', this.openPreview);
            element.removeEventListener('click', this.closePreview);
            element.removeEventListener('click', this.openPreviewMob);
            element.removeEventListener('click', this.closePreviewMob);
        });
    }
  
    initializeEventListeners() {
        this.previewBtns = this.defaultColl.querySelectorAll('[data-preview-size-btn]');
        this.previewBtns.forEach(btn => btn.addEventListener('click', this.openPreview.bind(this)));
    
        this.closeBtns = this.defaultColl.querySelectorAll('[data-preview-close-btn]');
        this.closeBtns.forEach(btn => btn.addEventListener('click', this.closePreview.bind(this)));
    
        this.previewMobBtns = this.defaultColl.querySelectorAll('[data-preview-size-mob-btn]');
        this.previewMobBtns.forEach(btn => btn.addEventListener('click', this.openPreviewMob.bind(this)));
    
        this.closeMobBtns = this.defaultColl.querySelectorAll('[data-preview-close-mob-btn]');
        this.closeMobBtns.forEach(btn => btn.addEventListener('click', this.closePreviewMob.bind(this)));
    }
  
    openPreview(event){
        event.preventDefault();
        let currentTarget = event.currentTarget;
    
        currentTarget.closest("[data-grid-inner]").querySelector('[data-grid-inner-top]').classList.add("hidden");
        currentTarget.closest("[data-grid-inner]").querySelector('[data-preview-size-grid]').classList.remove("hidden");
    }
    closePreview(event){
        event.preventDefault();
        let currentTarget = event.currentTarget;
    
        currentTarget.closest("[data-grid-inner]").querySelector('[data-grid-inner-top]').classList.remove("hidden");
        currentTarget.closest("[data-grid-inner]").querySelector('[data-preview-size-grid]').classList.add("hidden");
    
        let cardFooterGrid = currentTarget.closest("[data-grid-inner]").querySelector('[data-grid-inner-top] .card-footer');
        let previewSizeBtn = currentTarget.closest("[data-grid-inner]").querySelector('[data-grid-inner-top] [data-preview-size-btn]');
        if (cardFooterGrid) {
            cardFooterGrid.style.opacity = '1';
            cardFooterGrid.style.display = 'flex';
            cardFooterGrid.style.visibility = 'visible';
            previewSizeBtn.focus();
        }
    }
  
    openPreviewMob(event){
        event.preventDefault();
        let currentTarget = event.currentTarget;
    
        currentTarget.closest("[data-grid-inner]").querySelector('.preview-size-qv').classList.add("active");
    }
    closePreviewMob(event){
        event.preventDefault();
        let currentTarget = event.currentTarget;
    
        currentTarget.closest("[data-grid-inner]").querySelector('.preview-size-qv').classList.remove("active");
    }
  
    handleKeyPress(event) {
        if (event.key === "Escape") {
            this.gridInner = this.defaultColl.querySelectorAll('[data-grid-inner]');
            this.gridInner.forEach(grid => {
            grid.querySelector('[data-grid-inner-top]').classList.remove("hidden");
            grid.querySelector('[data-preview-size-grid]').classList.add("hidden");
            });
        }
    }
}
  
class CustomVariantRadios extends HTMLElement {
    constructor() {
        super();
    
        this.view = this.getAttribute('data-view'); 
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        if ((this.view === 'mobile' && !isMobile) || (this.view === 'desktop' && isMobile)) { return; }
    
        this.form = this.closest('form');
        this.gridInner = this.closest('[data-grid-inner]');
        if (!this.form || !this.gridInner) return;
    
        this.onVariantChange('load');
        this.addEventListener('change', this.onVariantChange);
    }
  
    getVariantsData() {
        if (!this.gridInner) return;
        
        const variantJSON = this.gridInner.querySelector('[data-variantJSON]');
        if (!variantJSON) return;
    
        try {
            this.variantData = this.variantData || JSON.parse(variantJSON.textContent);
            return this.variantData;
        } catch (error) {
            console.error('CustomVariantRadios Error:', error);
            return null;
        }
    }
  
    getCurrentVariant() {
        const variantData = this.getVariantsData();
        if (!variantData || !Array.isArray(variantData)) return;
    
        this.currentVariant = variantData.find((variant) => {
            return !variant.options.map((option, index) => {
            return this.options[index] === option;
            }).includes(false);
        });
    }
  
    getOptionsValue() {
        try {
            const fieldsets = Array.from(this.querySelectorAll('fieldset'));
            if (!fieldsets.length) return;
    
            this.options = fieldsets.map((fieldset) => {
            const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
            if (!checkedRadio) {
                // If no radio is checked, check the first available one
                const firstRadio = fieldset.querySelector('input:not([disabled])');
                if (firstRadio) {
                firstRadio.checked = true;
                return firstRadio.value;
                }
                return null;
            }
            return checkedRadio.value;
            });
    
            // Filter out any null values
            this.options = this.options.filter(option => option !== null);
        } catch (error) {
            console.error('CustomVariantRadios Error:', error);
            this.options = [];
        }
    }
  
    onVariantChange() {
        if (!this.form || !this.gridInner) return;
    
        this.getOptionsValue();
        
        if (!this.options || !this.options.length) return;
    
        this.getCurrentVariant();
    
        if (this.currentVariant) {
            this.updateVariantID(this.currentVariant);
            this.renderProductInfo(this.currentVariant, this.form);
        }
    }
  
    updateVariantID(currentVariant) {
        if (!currentVariant) return;
        this.gridInner.querySelectorAll('[data-preview-var-id]').forEach((element) => {
            if (element) element.setAttribute('data-preview-var-id', currentVariant.id);
        });
    }
  
    renderProductInfo(currentVariant, container) { 
        if (!currentVariant || !container) return;
    
        let price = Shopify.formatMoney(currentVariant.price, window.money_format);
        let cprice = Shopify.formatMoney(currentVariant.compare_at_price, window.money_format);
    
        let salePriceNew = container.querySelector('[data-salePriceNew]');
        let salePriceOld = container.querySelector('[data-salePriceOld]');
        let regularPrice = container.querySelector('[data-regularPrice]');
        let perDiscount  = container.querySelector('[data-perDiscount]');
        let discount = currentVariant.compare_at_price - currentVariant.price;
        discount = Math.round(Math.floor(discount) / 100) * 100;
    
        if (regularPrice) regularPrice.innerHTML = price;
        if (salePriceNew) salePriceNew.innerHTML = price;
        if (salePriceOld) salePriceOld.innerHTML = cprice;
    
        if(currentVariant.compare_at_price > currentVariant.price && discount > 0 ){
            if (perDiscount) perDiscount.innerHTML = `${Shopify.formatMoney(discount, window.money_format)} OFF`;
        }
    
        if (currentVariant.featured_image && currentVariant.featured_image != null) {
            let featuredImage = container.querySelector('[data-feauredImage]');
            let updatedSrc = currentVariant.featured_image.src.replace('.png', '_115x.png');
            if (updatedSrc && featuredImage) {
            featuredImage.src = updatedSrc;
            }
        }
    
        let previewAtcBtnDesHtml = `<span>Add To Cart</span>
                                    <span>${price}</span>
                                    <span>${currentVariant.compare_at_price > currentVariant.price ? cprice : ''}</span>
                                    <span class="visually-hidden">Add To Cart Sale Price ${price}</span>`;
                                    
        // Search in both container (form) and gridInner to ensure we find the button
        let previewAtcBtnDes = container.querySelector('.grid-footer .preview-atc-btn') || 
                               (this.gridInner ? this.gridInner.querySelector('.grid-footer .preview-atc-btn') : null);
        if (previewAtcBtnDes) {
            if (!currentVariant.available) {
                previewAtcBtnDes.textContent = "Out of Stock";
                previewAtcBtnDes.setAttribute("disabled", "true");
            } else {
                // Clear any placeholder text or existing content before setting new HTML
                previewAtcBtnDes.textContent = '';
                previewAtcBtnDes.innerHTML = previewAtcBtnDesHtml;
                previewAtcBtnDes.removeAttribute("disabled");
            }
        }
    
        let previewAtcBtnMob = container.querySelector('.qv-footer .preview-atc-btn');
        if (previewAtcBtnMob && previewAtcBtnMob != null) {
            if (!currentVariant.available) {
            previewAtcBtnMob.textContent = "Out of Stock";
            previewAtcBtnMob.setAttribute("disabled", "true");
            } else {
            previewAtcBtnMob.textContent = "Add to Cart";
            previewAtcBtnMob.removeAttribute("disabled");
            }
        }
        
        const ozValue = 29.5735;
        const unitConvertArr = this.currentVariant.option1.split('oz');
        const selectedVal  = this.currentVariant.option1;
        let selectedValSliced;
        if(this.currentVariant.option1.includes('oz')){
            selectedValSliced = selectedVal.slice(0,selectedVal.length - 1);
        } else {
            selectedValSliced = selectedVal.slice(0,selectedVal.length);
        } 
        if(selectedVal.includes('Tester')){
            let selectedValArr = selectedVal.split("Tester");
            selectedValSliced = selectedValArr[0].slice(0,selectedValArr[0].length - 2);
            selectedValSliced  = selectedValSliced + " Tester";
        }
        const unitConvertArrValue = Number(unitConvertArr[0]);
        const conversions = { 0.05: 1.5,0.17: 5,0.5: 15,0.8: 25,1.0: 30,1.4: 40,1.7: 50,2.0: 60,2.5: 75,2.7: 80,3.0: 90,3.3: 100,3.4: 100,4.2: 125,5.0: 150,6.7: 200, };
        const unitValue = conversions[unitConvertArrValue] || Math.floor(ozValue * unitConvertArrValue);
        
        let varTitle = container.querySelector('[data-varTitle]');
        if(varTitle) varTitle.innerHTML = `${selectedValSliced}`
        if(this.currentVariant.option1.includes('oz')){ 
            if(varTitle) varTitle.innerHTML = `${selectedValSliced} / ${unitValue}ml`
        } else {
            if(varTitle) varTitle.innerHTML = `${selectedValSliced}`
        }
    
        const availableVarQty = this.currentVariant.inventory_quantity;
        const selectElement = this.form.querySelector('.quantity__select [data-quantity-select]');
        selectElement.innerHTML = '';
    
        for (let i = 1; i <= 10; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.textContent = i;
            if (i > availableVarQty) { option.disabled = true; }
    
            selectElement.appendChild(option);
        }
      
    }
  
}
customElements.define('custom-variant-radios', CustomVariantRadios);

document.addEventListener("DOMContentLoaded", function () {
    const cardFooters = document.querySelectorAll("[data-grid-inner] .product-bottom .card-footer");
    if (!cardFooters.length) return;
  
    function manageTabIndex() {
        const isDesktop = window.innerWidth >= 768;
        cardFooters.forEach(cardFooter => {
            cardFooter.tabIndex = isDesktop ? 0 : -1;
        });
    }
    manageTabIndex();
  
    let debounceTimer;
    window.addEventListener("resize", function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(manageTabIndex, 150);
    });
});
  
document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (event) {
        if (event.target.matches("[data-description-readmore], [data-description-readless]")) {
            event.preventDefault();
            let parent = event.target.closest("[data-description]");
            if (!parent) return;
    
            let fullDesc = parent.querySelector("[data-description-full]");
            let shortDesc = parent.querySelector("[data-description-short]");
            if (!fullDesc || !shortDesc) return;
    
            let isReadMore = event.target.hasAttribute("data-description-readmore");
            fullDesc.style.display = isReadMore ? "block" : "none";
            shortDesc.style.display = isReadMore ? "none" : "block";
        }
    });
});
  
})();
